import { CHECKBOX_TYPE } from './Checkbox.constants'

export function isCheckboxTableType(type) {
  return type === CHECKBOX_TYPE.table || type === CHECKBOX_TYPE.tableRow
}
